import { InputformatService } from 'src/app/services/inputformat.service';
import { Component, Inject, OnInit } from '@angular/core';
import { environment } from "src/environments/environment";

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';
import { FarmerService } from 'src/app/services/farmer.service';
import { Router } from '@angular/router';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { BankcityService } from 'src/app/services/bankcity.service';
import { EventType } from 'src/enum/eventtype';
import * as moment from 'moment';
import * as _ from 'lodash';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';

@Component({
  selector: 'app-aefarmerpaymentpopup',
  templateUrl: './aefarmerpaymentpopup.component.html',
  styleUrls: ['./aefarmerpaymentpopup.component.scss']
})
export class AefarmerpaymentpopupComponent implements OnInit {
  showNotes: boolean = true;
  form: FormGroup;
  form1: FormGroup;
  id: any;
  actionId: any;
  isShow: boolean
  filterCityName: any = []
  bankName: any
  bankNameList: any
  filterbranchName: any[] = [];
  branchName: any[] = [];
  CityName: any[] = [];
  city: boolean = false;
  branch: boolean = false;
  public eventEnum = EventType;
  today: Date;
  session: any;
  data: any[] = [];
  serveyNumber: any
  subDivisionId: any;
  landOptions: { survey: string, sub: string }[] = [];
  surveyOptions: string[] = [];
  subDivisionOptions: string[] = [];
  confirmRefund: boolean = false;
  confirmRefundhrs: boolean = false;
  maxDate: Date;
  minDate: Date;
  showRemarks: boolean = false;
  isDisabled: boolean = false;
  adangalAvailable: boolean = true;
  adangalMissing: boolean = false;
  isRejectDisabled: boolean = false;
  statusTypeList: any[];
  filterstatusTypeList: any[];
  preInspectinfileName: any;
  files: any;
  filesResult: any;
  inspectionData: any;
  fileType: number;
  farmerList: any[];
  filterfarmerList: any[];
  ins_filename: any;
  tinfiles: any;
  registerData: any[] = [];
  form2: FormGroup;
  bankForm: FormGroup;
  bankStateId: number = 31;
  bankOptions: any[] = [];
  filterBankOptions: any[] = [];
  cityOptions: any[] = [];
  filterCityOptions: any[] = [];
  branchOptions: any[] = [];
  filterBranchOptions: any[] = [];
  loading: boolean;
  showFarmerTypeUpload = false;
  certificateName: any
  fileType1: number;
  filesResult1: any;
  photo: any;
  fileType2: number;
  filesResult2: any;
  community: any;
  aadhar: any;
  fileType3: number;
  filesResult3: any;
  patta: any;
  fileType4: number;
  filesResult4: any;
  chitta: any;
  fileType5: number;
  filesResult5: any;
  adangal: any;
  filesResult6: any;
  fileType6: any;
  fmb: any;
  fileType7: number;
  filesResult7: any;
  passbookFilename: any;
  passbookFilePath: any;
  fileType8: number;
  filesResult8: any;
  rcBookFilename: any;
  rcBookFilePath: any;
  fileType9: number;
  filesResult9: any;
  clearvalidatersfarmerType: boolean = false;
  roleId: number;
  public roleEnum = RoleType
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private alertService: AlertService,
    private farmerService: FarmerService,
    private userSessionService: UserSessionService,
    public dialogRef: MatDialogRef<AefarmerpaymentpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    public inputformatService: InputformatService,
    private bankcityService: BankcityService
  ) {
    debugger
    this.session = this.dataRecievedData.session;
    this.id = this.session.id
    this.serveyNumber = this.session.serveyNumber;
    this.subDivisionId = this.session.subDivisionNumber;
    this.roleId = this.userSessionService.roleId()
  }


  ngOnInit(): void {
    this.initializeValidators()
    this.getfarmerList()
    this.getrejection()
    this.loadBankDetails()
    this.showNotes = true;
    this.today = new Date();
    this.form.controls['SurveyNumber'].patchValue(this.serveyNumber);
    this.form.controls['SubdivisionNumber'].patchValue(this.subDivisionId);
    this.loadLandOptions();
    this.form.controls['farmerType'].setValue(this.session.farmerType)
    if (this.session.farmerType != 4) {
      this.showFarmerTypeUpload = true;
    }
    this.certificateName = this.session.farmerTypeImagePath;
    this.community = this.session.communityImagePath;
    this.photo = this.session.farmerImagePath;
    this.aadhar = this.session.aadharImagePath;
    this.patta = this.session.pattaImagePath;
    this.chitta = this.session.chittaImagePath
    this.adangal = this.session.adangalImagePath;
    this.fmb = this.session.fmbImagePath
    const savedRcBookPath = this.session?.rcBookImagePath || '';
    this.rcBookFilePath = savedRcBookPath && !savedRcBookPath.startsWith('data:') ? savedRcBookPath : '';
    this.rcBookFilename = this.rcBookFilePath ? this.rcBookFilePath.split('/').pop() : '';

    this.maxDate = new Date();
    var date = this.session.bookedTs;
    this.minDate = new Date(moment(date).format("YYYY, MM, DD"));

  }



  loadLandOptions() {
    const all = this.session?.allLandDetails || [];
    this.landOptions = [];
    all.filter(l => l.surveyNumber).forEach(l => {
      const sub = l.subSurveyNumber || '';
      if (!this.landOptions.some(x => x.survey == l.surveyNumber && x.sub == sub)) {
        this.landOptions.push({ survey: l.surveyNumber, sub });
      }
    });
    // keep the currently booked land selectable even if AgriStack list lacks it
    if (this.serveyNumber && !this.landOptions.some(l => l.survey == this.serveyNumber && l.sub == (this.subDivisionId || ''))) {
      this.landOptions.push({ survey: this.serveyNumber, sub: this.subDivisionId || '' });
    }
    this.surveyOptions = Array.from(new Set(this.landOptions.map(l => l.survey)));
    this.refreshSubDivisions(this.form.value.SurveyNumber);
  }

  refreshSubDivisions(survey: string) {
    this.subDivisionOptions = Array.from(new Set(this.landOptions.filter(l => l.survey == survey).map(l => l.sub)));
  }

  onSurveyChange(survey: string) {
    this.refreshSubDivisions(survey);
    this.form.controls['SubdivisionNumber'].setValue(this.subDivisionOptions.length === 1 ? this.subDivisionOptions[0] : '');
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      SurveyNumber: ['', Validators.required],
      SubdivisionNumber: ['', Validators.required],
      bydate: [''],
      aejename: ['', Validators.required],
      inspectionTs: ['', Validators.required],
      inspectionReport: ["", Validators.required],
      ins_filename: [""],
      farmerType: [''],
      farmerCertificate: [""],
      farmerPhoto: [''],
      aadhar: [''],
      community: [''],
      patta: [''],
      chitta: [''],
      adangal: [''],
      fmbSketch: [''],
      rcBook: [''],
    })
    this.form1 = this.formBuilder.group({
      remarks: ['', Validators.required],
      rejectionList: ["",]
    })
    this.form2 = this.formBuilder.group({
      bysubsityconform: [''],
      remark: ['', Validators.required],
    })
    this.bankForm = this.formBuilder.group({
      bankName: [''],
      cityName: [''],
      branchName: [''],
      ifsc: [''],
      accountNumber: [''],
      passbook: [''],
      accountName: [''],
    })
  }
  getrejection() {
    this.farmerService.getRejectionlist(true).subscribe((res) => {
      this.statusTypeList = res
      this.filterstatusTypeList = this.statusTypeList.slice();
    })
  }

  // bankName / cityName / branchName controls hold the selected lookup ids (they render as dropdowns)
  loadBankDetails() {
    const bankId = Number(this.session?.farmerBankId || 0);
    const cityId = Number(this.session?.farmerCityId || 0);
    const branchId = Number(this.session?.farmerBranchId || 0);
    this.bankStateId = Number(this.session?.farmerStateId || this.session?.stateId || this.session?.state || 31);
    const savedPassbookPath = this.session?.farmerBankPassBookImagePath || this.session?.bankPassbook || '';

    this.bankForm.patchValue({
      bankName: bankId || null,
      cityName: cityId || null,
      branchName: branchId || null,
      ifsc: this.session?.ifsc || '',
      accountNumber: this.session?.acNo || '',
      passbook: savedPassbookPath,
      accountName: this.session?.farmerAccountHolderName || '',
    });
    this.passbookFilePath = savedPassbookPath && !savedPassbookPath.startsWith('data:') ? savedPassbookPath : '';
    this.passbookFilename = this.passbookFilePath ? this.passbookFilePath.split('/').pop() : '';

    this.loadBankList(() => {
      if (bankId > 0) {
        this.loadCityList(bankId, () => {
          if (cityId > 0) { this.loadBranchList(cityId); }
        });
      }
    });
  }

  private loadBankList(done?: () => void) {
    this.bankcityService.getBank(this.bankStateId, true).subscribe((res) => {
      this.bankOptions = (Array.isArray(res) ? res : []).filter((i: any) => i.key);
      this.filterBankOptions = this.bankOptions;
      if (done) { done(); }
    });
  }

  private loadCityList(bankId: number, done?: () => void) {
    this.bankcityService.getCity(this.bankStateId, bankId, true).subscribe((res) => {
      this.cityOptions = Array.isArray(res) ? res : [];
      this.filterCityOptions = this.cityOptions;
      if (done) { done(); }
    });
  }

  private loadBranchList(cityId: number, done?: () => void) {
    this.farmerService.getbranch(cityId, true).subscribe((res) => {
      this.branchOptions = Array.isArray(res) ? res : [];
      this.filterBranchOptions = this.branchOptions;
      if (done) { done(); }
    });
  }

  onBankSelected() {
    this.bankForm.patchValue({ cityName: null, branchName: null, ifsc: '' });
    this.cityOptions = this.filterCityOptions = [];
    this.branchOptions = this.filterBranchOptions = [];
    const bankId = this.bankForm.value.bankName;
    if (!bankId) { return; }
    this.loadCityList(bankId, () => {
      if (this.cityOptions.length === 1) {
        this.bankForm.patchValue({ cityName: this.cityOptions[0].key });
        this.onCitySelected();
      }
    });
  }

  onCitySelected() {
    this.bankForm.patchValue({ branchName: null, ifsc: '' });
    this.branchOptions = this.filterBranchOptions = [];
    const cityId = this.bankForm.value.cityName;
    if (!cityId) { return; }
    this.loadBranchList(cityId, () => {
      if (this.branchOptions.length === 1) {
        this.bankForm.patchValue({ branchName: this.branchOptions[0].key });
        this.onBranchSelected();
      }
    });
  }

  onBranchSelected() {
    const branch = this.branchOptions.find((i: any) => i.key == this.bankForm.value.branchName);
    this.bankForm.patchValue({ ifsc: branch?.ifsc || '' });
  }

  // Typing a full 11-character IFSC patches bank, city and branch; each can still be changed afterwards
  onIfscInput() {
    const ifsc = (this.bankForm.value.ifsc || '').toString().trim().toUpperCase();
    if (ifsc !== this.bankForm.value.ifsc) {
      this.bankForm.patchValue({ ifsc }, { emitEvent: false });
    }
    if (ifsc.length !== 11) { return; }
    this.bankcityService.getIfscDetails(ifsc).subscribe((d) => {
      if (!d || !d.branchId || this.bankForm.value.ifsc !== ifsc) {
        return;
      }
      this.bankForm.patchValue({ bankName: d.bankId, cityName: d.cityId, branchName: d.branchId });
      this.loadCityList(d.bankId, () => {
        this.loadBranchList(d.cityId);
      });
    });
  }

  hasBankDetails(): boolean {
    return !!(this.session && this.session.bankName && this.session.bankName.trim());
  }
  adhaarDowndload(productListdata: any) {
    let src =
      environment.imageBaseUrl +
      "DBT/Aadhar/" +
      productListdata.aadharImagePath;

    window.open(encodeURI(src), "_blank");

  }
  FarmertypeDownload(productListdata: any) {
    let src =
      environment.imageBaseUrl +
      "DBT/FarmerType/" +
      productListdata.farmerTypeImagePath;

    window.open(encodeURI(src), "_blank");
  }
  FarmerImgDownload(session: any) {
    let src =
      environment.imageBaseUrl +
      "DBT/FarmerImage/" +
      session.farmerImagePath;
    window.open(encodeURI(src), "_blank");
  }
  communityImgDownload(session: any) {
    let src =
      environment.imageBaseUrl +
      "DBT/Community/" +
      session.communityImagePath;

    window.open(encodeURI(src), "_blank");
  }
  PattaDowndload(session) {
    let src =
      environment.imageBaseUrl +
      "DBT/Patta/" +
      session.pattaImagePath;

    window.open(encodeURI(src), "_blank");
  }
  // Hide the Adangal download icon when the file is missing (404) on the image server
  // Called when "Farmer details all are Correct?" = Yes: is the saved Adangal really on the server?
  checkAdangalAvailable() {
    const path = this.session?.adangalImagePath;
    this.adangalAvailable = false; // hidden until the server confirms the file
    if (!path) {
      this.adangalMissing = true;
      return;
    }
    const src = encodeURI(environment.imageBaseUrl + "DBT/Adangal/" + path);
    this.fileOpens(src).then(opens => {
      this.adangalAvailable = opens;
      this.adangalMissing = !opens;
      if (!opens && !this.form.controls['adangal'].value) {
        this.adangal = null; // don't show a filename for a file that isn't there
      }
    });
  }
  private fileOpens(src: string): Promise<boolean> {
    if (/\.pdf$/i.test(src)) {
      return fetch(src, { method: 'HEAD' }).then(res => res.ok).catch(() => false);
    }
    // an <img> load works cross-origin, so no CORS dependency for images
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = src;
    });
  }
  adangalDownload(session) {
    let src =
      environment.imageBaseUrl +
      "DBT/Adangal/" +
      session.adangalImagePath;

    window.open(encodeURI(src), "_blank");
  }
  ChittaDownload(session) {
    let src =
      environment.imageBaseUrl +
      "DBT/Chitta/" +
      session.chittaImagePath;

    window.open(encodeURI(src), "_blank");
  }
  FmbDownload(session) {
    let src =
      environment.imageBaseUrl +
      "DBT/FMB/" +
      session.fmbImagePath;

    window.open(encodeURI(src), "_blank");
  }
  // getCurrent(event:any){

  // }
  onSave() {
    if (this.clearvalidatersfarmerType == true) {
      this.form.controls["farmerCertificate"].setValidators(Validators.required);
      this.form.controls["farmerCertificate"].updateValueAndValidity();
    } else {
      this.form.controls["farmerCertificate"].clearValidators();
      this.form.controls["farmerCertificate"].updateValueAndValidity();
    }
    this.form2.controls["bysubsityconform"].setValidators(Validators.required);
    this.form2.controls["bysubsityconform"].updateValueAndValidity();
    // Adangal copy is mandatory: block the save when none is saved on the server and none is newly chosen
    // if (this.adangalMissing && !this.form.get('adangal').value) {
    //   this.form.get('adangal').markAsTouched();
    //   this.alertService.error("Please upload the Adangal copy");
    //   return;
    // }
    this.loading = true;
    this.isDisabled = true;
    if (this.form.valid && this.form2.valid) {
      let request = {
        "id": this.id,
        "acNo": this.bankForm.value.accountNumber || "",
        "accountHolderName": this.bankForm.value.accountName || "",
        "cityId": this.bankForm.value.cityName || this.session?.farmerCityId || null,
        "branchId": this.bankForm.value.branchName || this.session?.farmerBranchId || null,
        "ifsc": this.bankForm.value.ifsc || "",
        "dbtSchemeId": null,
        "dbtComponentId": null,
        "dbtProductId": null,
        "dbtProductInfoId": null,
        "dbtManufacturerId": null,
        "dbtDealerId": null,
        "eventType": this.eventEnum.PreInspectionbyAE,
        "bankId": this.bankForm.value.bankName || this.session?.farmerBankId || null,
        "transactionType": 0,
        "paymentTs": null,
        "receiptNumber": "",
        "productCost": 0,
        "gstPercentage": 0,
        "subsidyAmount": 0,
        "totalCost": 0,
        "engineNumber": "",
        "chassisNumber": "",
        "registrationNumber": "",
        "preInspectionTs": moment(this.form.value.inspectionTs).format('YYYY-MM-DD'),
        "preInspectedBy": this.form.value.aejename,
        "deliveryTs": null,
        "remarks": this.form2.value.remarks,
        "ServeyNumber": this.form.value.SurveyNumber,
        "SubDivisionNumber": this.form.value.SubdivisionNumber,
        "attachment": this.registerData,
        "rejectionType": 0,
        "farmerType": this.form.value.farmerType,
        "isAdditionalSubsidyEligible": this.form2.value.bysubsityconform == "Yes" ? true : false
      };
      // setTimeout(() => {
      this.farmerService.farmerSave(request).subscribe(res => {
        if (res && res.isSuccess) {
          this.loading = false;
          this.isDisabled = false;
          this.loading = false;
          this.alertService.success("Pre Inspection Completed Successfully.");
          this.dialogRef.close();
          this.router.navigate(['/aefarmerbooking'])
        } else {
          this.loading = false;
          this.isDisabled = false;
        }

      })
      // }, 1000);
    } else {
      this.loading = false;
      this.isDisabled = false;
      this.validateFormControl();
      this.validateForm2Control();
      this.alertService.error("Please fill mandatory fields");
    }
  }

  Reject() {
    debugger
    if (this.form.valid && this.form1.valid) {
      this.isRejectDisabled = true;
      this.loading = true;
      let request = {
        "id": this.id,
        "acNo": "",
        "cityId": null,
        "branchId": null,
        "ifsc": "",
        "dbtSchemeId": null,
        "dbtComponentId": null,
        "dbtProductId": null,
        "dbtProductInfoId": null,
        "dbtManufacturerId": null,
        "dbtDealerId": null,
        "eventType": this.eventEnum.RejectedbyAE,
        "bankId": null,
        "transactionType": 0,
        "paymentTs": null,
        "receiptNumber": "",
        "productCost": 0,
        "gstPercentage": 0,
        "subsidyAmount": 0,
        "totalCost": 0,
        "engineNumber": "",
        "chassisNumber": "",
        "registrationNumber": "",
        "deliveryTs": null,
        "preInspectionTs": moment(this.form.value.inspectionTs).format('YYYY-MM-DD'),
        "preInspectedBy": this.form.value.aejename,
        "remarks": this.form1.value.remarks,
        "ServeyNumber": "",
        "SubDivisionNumber": "",
        "attachment": this.registerData,
        "rejectionType": this.form1.value.rejectionList
      };
      this.farmerService.farmerSave(request).subscribe(res => {
        if (res && res.isSuccess) {
          this.alertService.success("AE Verified Successfully.");
          this.dialogRef.close();
          this.router.navigate(['/aefarmerbooking'])
        }
        this.isRejectDisabled = false;
        this.loading = false;
      })
    } else {
      this.validateFormControl();
      this.validateForm1Control();
    }
  }
  downloadattachament() {
    this.farmerService.getInspectionReport(this.id, 1, true).subscribe((res) => {
      if (res) {
        const linkSource = "data:application/pdf;base64, " + res;
        const downloadLink = document.createElement("a");
        const fileName = "AE/JE Verification Report.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
    // const linkSource = "assets/FileTemplates/Pre - Verification .docx";
    // const downloadLink = document.createElement('a');
    // const fileName = "Pre-inspection Format";
    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
    // window.open("assets/FileTemplates/pre-Verification.docx", "_blank");
  }
  FarmerTypeChange(event) {
    if (event.value !== 4) {
      this.showFarmerTypeUpload = true;
      if (this.session.farmerType == event.value) {
        this.clearvalidatersfarmerType = false;
        this.certificateName = this.session.farmerTypeImagePath;
      } else {
        this.clearvalidatersfarmerType = true;
        this.certificateName = null;
      }
    } else {
      this.showFarmerTypeUpload = false;
    }


  }
  onChangeIsPicker(e: any) {
    this.showRemarks = true
    if (e.target.value == "Yes") {
      this.confirmRefund = false
      this.confirmRefundhrs = true
      this.checkAdangalAvailable();

      this.form.controls["SurveyNumber"].setValidators(Validators.required);
      this.form.controls["SurveyNumber"].updateValueAndValidity();
      this.form.controls["SubdivisionNumber"].setValidators(Validators.required);
      this.form.controls["SubdivisionNumber"].updateValueAndValidity();
    }
    else {
      this.confirmRefund = true
      this.confirmRefundhrs = false

      this.form.controls["SurveyNumber"].clearValidators();
      this.form.controls["SurveyNumber"].updateValueAndValidity();
      this.form.controls["SubdivisionNumber"].clearValidators();
      this.form.controls["SubdivisionNumber"].updateValueAndValidity();
    }
  }

  preInspectionUpload(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.ins_filename = file.name;
        let checkType = file.type;
        let getFileType = checkType.split('/');
        if (getFileType[1] == 'pdf') {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = (event: any) => {
            this.tinfiles = event.target.result;
            this.filesResult = event.target.result.split(',')[1];
            this.form.controls['inspectionReport'].setValue(
              this.filesResult
            );
            this.form.controls['ins_filename'].setValue(file.name);
            this.registerData.push({
              id: 0,
              attachmentFilename: file.name,
              attachmentType: 45,
              fileType: this.fileType,
              base64String: this.filesResult
            });
          };
        }
      }
      else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  farmeCertificateUpload(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.certificateName = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType = 2;
      } else {
        this.fileType = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult = event.target.result.split(',')[1];
          this.form.controls['farmerCertificate'].setValue(
            this.filesResult
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 24,
            fileType: this.fileType,
            base64String: this.filesResult
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  farmeCommunity(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.community = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType1 = 2;
      } else {
        this.fileType1 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult1 = event.target.result.split(',')[1];
          this.form.controls['community'].setValue(
            this.filesResult1
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 23,
            fileType: this.fileType1,
            base64String: this.filesResult1
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  farmerPhoto(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.photo = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType2 = 2;
      } else {
        this.fileType2 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult2 = event.target.result.split(',')[1];
          this.form.controls['farmerPhoto'].setValue(
            this.filesResult2
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 38,
            fileType: this.fileType2,
            base64String: this.filesResult2
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  farmerAadhar(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.aadhar = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType3 = 2;
      } else {
        this.fileType3 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult3 = event.target.result.split(',')[1];
          this.form.controls['aadhar'].setValue(
            this.filesResult3
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 35,
            fileType: this.fileType3,
            base64String: this.filesResult3
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }

  farmerPatta(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.patta = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType4 = 2;
      } else {
        this.fileType4 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult4 = event.target.result.split(',')[1];
          this.form.controls['patta'].setValue(
            this.filesResult4
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 43,
            fileType: this.fileType4,
            base64String: this.filesResult4
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  farmerchitta(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.chitta = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType5 = 2;
      } else {
        this.fileType5 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult5 = event.target.result.split(',')[1];
          this.form.controls['chitta'].setValue(
            this.filesResult5
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 33,
            fileType: this.fileType5,
            base64String: this.filesResult5
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  farmerAdangal(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.adangal = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType3 = 2;
      } else {
        this.fileType3 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult6 = event.target.result.split(',')[1];
          this.form.controls['adangal'].setValue(
            this.filesResult6
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 44,
            fileType: this.fileType6,
            base64String: this.filesResult6
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  farmerFmb(event) {

    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      this.fmb = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType7 = 2;
      } else {
        this.fileType7 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult7 = event.target.result.split(',')[1];
          this.form.controls['fmbSketch'].setValue(
            this.filesResult7
          );
          // this.form.controls['certificateName'].setValue(file.name);
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 34,
            fileType: this.fileType7,
            base64String: this.filesResult7
          });
        };
      }

    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }
  next() {
    this.dialogRef.close();
    this.router.navigate(['/aefarmerbookingview'])
  }
  getfarmerList() {
    this.farmerService.getfarmertypeLookup(true).subscribe(res => {
      if (res) {
        this.farmerList = [];
        this.filterfarmerList = [];
        this.farmerList = res.filter((i: { key: number }) => i.key);
        this.filterfarmerList = this.farmerList;
        this.filterfarmerList = _.orderBy(this.farmerList, ['key'], ['asc']);
      }
    });
    this.farmerList = this.filterfarmerList;
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }

  validateForm1Control() {
    Object.keys(this.form1.controls).forEach((field) => {
      const control = this.form1.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  validateForm2Control() {
    Object.keys(this.form2.controls).forEach((field) => {
      const control = this.form2.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }
  onInput(event: any, regexPattern: any): void {
    this.inputformatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }

  passbookUpload(event) {
    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize > 2048) {
        this.alertService.error('File size exceeds 2 MB');
        return;
      }
      this.passbookFilename = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType8 = 2;
      } else {
        this.fileType8 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult8 = event.target.result.split(',')[1];
          this.bankForm.controls['passbook'].setValue(
            this.filesResult8
          );
          this.passbookFilePath = file.name;
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 72,
            fileType: this.fileType8,
            base64String: this.filesResult8
          });
        };
      }
    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }

  downloadPassbook() {
    if (this.passbookFilePath) {
      const src = this.filesResult8
        ? `data:${this.fileType8 === 2 ? 'application/pdf' : 'image/*'};base64,${this.filesResult8}`
        : this.passbookFilePath.startsWith('http') || this.passbookFilePath.startsWith('data:')
          ? this.passbookFilePath
          : environment.imageBaseUrl + "DBT/FarmerPassBook/" + this.passbookFilePath;
      window.open(encodeURI(src), "_blank");
    }
  }

  rcBookUpload(event) {
    const file = event.target.files[0];
    if (
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/jpeg'
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize > 2048) {
        this.alertService.error('File size exceeds 2 MB');
        return;
      }
      this.rcBookFilename = file.name;
      let checkType = file.type;
      let getFileType = checkType.split('/');
      if (getFileType[1] == 'pdf') {
        this.fileType9 = 2;
      } else {
        this.fileType9 = 1;
      }
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.tinfiles = event.target.result;
          this.filesResult9 = event.target.result.split(',')[1];
          this.form.controls['rcBook'].setValue(
            this.filesResult9
          );
          this.rcBookFilePath = file.name;
          this.registerData.push({
            id: 0,
            attachmentFilename: file.name,
            attachmentType: 31,
            fileType: this.fileType9,
            base64String: this.filesResult9
          });
        };
      }
    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  }

  downloadRcBook() {
    if (this.rcBookFilePath) {
      const src = this.filesResult9
        ? `data:${this.fileType9 === 2 ? 'application/pdf' : 'image/*'};base64,${this.filesResult9}`
        : this.rcBookFilePath.startsWith('http') || this.rcBookFilePath.startsWith('data:')
          ? this.rcBookFilePath
          : environment.imageBaseUrl + "DBT/DBTRcBook/" + this.rcBookFilePath;
      window.open(encodeURI(src), "_blank");
    }
  }
}
